import {keyframes} from 'styled-components';

const FadeAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 100%;
  }
`;

export default FadeAnimation;
